export default {
  namespaced: true,
  state: {
    viewedDocument: null,
    documentId: null,
    viewedDocumentDialog: false
  },
  mutations: {
    setViewedDocument: (state, payload) => {
      state.viewedDocument = payload
    },
    setDocumentId: (state, payload) => {
      state.documentId = payload
    },
    setViewedDocumentDialog: (state, display) => {
      state.viewedDocumentDialog = display
    }
  }
}
